module.exports = __webpack_public_path__ + "img/access-icon.2cf6691e.svg";